export const config = {
  apiKey: "AIzaSyArZ6LYOUIVfr3H5MaCIzaujbZuUgcvvkI",
  projectId: "packimpex-scw",
  databaseURL: "https://packimpex-scw.firebaseio.com",
  // authDomain: "packimpex-scw.web.app",
  authDomain: "relox-pulse.packimpex.com",
  storageBucket: "gs://packimpex-scw.appspot.com/",
};
